import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from "next/image"

import { Grid, Col } from 'components/grid'

import * as S from './styles'

const Fiduciary: FC = memo(() => (
  <S.Section id="alienacao-fiduciaria" $bg="medium">
    <Grid col={{ phone: 1, tablet: 2 }}>
      <Col col={{ desktop: 4 }} start={{ desktop: 2 }}>
        <S.ImageWrapper>
          <NextImage
            src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/home-equity/thinking.png`}
            alt="Homem pensativo"
            width="600"
            height="433"
            sizes="100vw"
            style={{
              width: "100%",
              height: "auto"
            }} />
        </S.ImageWrapper>
      </Col>
      <Col col={{ desktop: 5 }} start={{ desktop: 7 }}>
        <S.Infos>
          <Text className="subtitle" size="caption" weight="medium" uppercase>
            Alienação Fiduciária
          </Text>
          <Text as="h2" size="heading3" weight="medium">
            O que é{' '}
            <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
              alienação fiduciária?
            </Text>
          </Text>
          <Text color="var(--colors-neutral-text-weak)">
            Alienação fiduciária é o instrumento jurídico que permite usar um bem como garantia para um empréstimo. Para
            ficar mais claro, vamos olhar para os termos separadamente.
          </Text>
          <Text color="var(--colors-neutral-text-weak)">
            Alienação deriva de alienar, que significa transferir a propriedade de um bem para terceiros. Já fiduciária
            remete a fiduciante que, neste tipo de modalidade de empréstimo, é a parte responsável pelo pagamento da
            dívida. Então, na prática, fazer alienação fiduciária no Home Equity significa transferir a propriedade de
            um imóvel para quem concede o empréstimo.
          </Text>
          <Text color="var(--colors-neutral-text-weak)">
            Mas atenção, isso não significa que o imóvel deixa de ser seu. Por meio do Home Equity, o bem continua com o
            proprietário original, que pode continuar usufruindo dele. Se for a sua casa, você continua morando nela
            normalmente.
          </Text>
          <Text color="var(--colors-neutral-text-weak)">
            Na alienação fiduciária, a propriedade apenas entra como garantia do pagamento das prestações. É isso que
            permite à instituição financeira praticar juros baixos e tornar menos burocrático o processo de aquisição de
            crédito. Talvez você esteja se perguntando: &quot;qual a diferença entre Home Equity e hipoteca
            tradicional?&quot;
          </Text>
          <Text color="var(--colors-neutral-text-weak)">
            A diferença entre Home Equity e hipoteca tradicional é a forma como a garantia é apresentada em troca do
            empréstimo, afinal, em ambos os casos um imóvel é apresentado como garantia. No entanto, na hipoteca
            tradicional, não há a alienação fiduciária. Dessa maneira, a instituição financeira tem menos garantia de
            que vai receber o dinheiro emprestado. Com menos garantias, o que acontece? Isso mesmo. Juros mais altos.
          </Text>
          <Text color="var(--colors-neutral-text-weak)">
            Então, se você quer pagar menos pelo empréstimo, o Home Equity é a melhor opção. As taxas nesta modalidade
            de crédito são as mais baixas do mercado!
          </Text>
        </S.Infos>
      </Col>
    </Grid>
  </S.Section>
))

Fiduciary.displayName = 'Fiduciary'

export default Fiduciary
